<template>
  <div>
    <div style="margin-top:3px;">
      <el-carousel :interval="5000" arrow="always">
        <el-carousel-item v-for="item in indexData.logoImageList">
          <img style="width:100%;height:100%;border-radius: 4px;" :src="globalUrl.resourceUrl+item.imageUrl" alt="">
        </el-carousel-item>
      </el-carousel>
    </div>
    <!-- 公司简介 -->
    <div class="cpy_info">
      <el-card class="box-card">
        <div slot="header" class="clearfix">
          <span>公司简介</span>
          <el-button style="float: right; padding: 3px 0" type="text" @click="clickToRouter('/cpyIntroduction')">更多</el-button>
        </div>
        <div v-html="indexData.cpyInfo" class="text2 item">
        </div>
      </el-card>
    </div>

    <!-- 内容 -->
    <el-row :gutter="20">
      <el-col :span="6">
          <div class="article">
            <el-card class="box-card">
              <div slot="header" class="clearfix">
                <span>政策法规</span>
                <el-button style="float: right; padding: 3px 0" type="text" @click="clickToRouter('/policyList')">更多</el-button>
              </div>
              <ul class="article-list">
                <li  v-for="item of indexData.policyRegulationList" >
                    <el-tooltip effect="dark" :content="item.title" placement="top-start">
                      <router-link class="show-ellipsis" :to="{path:'/policyContent?contentId='+item.id}">{{item.title}}</router-link>
                    </el-tooltip>
                    <span class="fr">{{item.publishTime}}</span>
                    <span class="clearfix"></span>
                </li>
              </ul>
            </el-card>
          </div>
      </el-col>
      <el-col :span="6">
        <div class="article">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>政府采购</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="clickToRouter('/purchaseList')">更多</el-button>
            </div>
            <div  class="text item">
              <li  v-for="item of indexData.govPurchaseList">
                  <el-tooltip effect="dark" :content="item.title" placement="top-start">
                    <router-link class="show-ellipsis" :to="{path:'/purchaseContent?contentId='+item.id}">{{item.title}}</router-link>
                  </el-tooltip>
                  <span class="fr">{{item.publishTime}}</span>
                  <span class="clearfix"></span>
              </li>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="article">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>工程招标信息</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="clickToRouter('/tenderingList')">更多</el-button>
            </div>
            <div  class="text item">
              <li  v-for="item of indexData.projectTenderingList">
                  <el-tooltip effect="dark" :content="item.title" placement="top-start">
                    <router-link class="show-ellipsis" :to="{path:'/tenderingContent?contentId='+item.id}">{{item.title}}</router-link>
                  </el-tooltip>
                  <span class="fr">{{item.publishTime}}</span>
                  <span class="clearfix"></span>
              </li>
            </div>
          </el-card>
        </div>
      </el-col>
      <el-col :span="6">
        <div class="article">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>收费标准</span>
              <el-button style="float: right; padding: 3px 0" type="text" @click="clickToRouter('/feeList')">更多</el-button>
            </div>
            <div  class="text item">
              <li  v-for="item of indexData.feeStandardList">
                  <el-tooltip effect="dark" :content="item.title" placement="top-start">
                    <router-link class="show-ellipsis" :to="{path:'/feeContent?contentId='+item.id}">{{item.title}}</router-link>
                  </el-tooltip>
                  <span class="fr">{{item.publishTime}}</span>
                  <span class="clearfix"></span>
              </li>
            </div>
          </el-card>
        </div>
      </el-col>
    </el-row>

    <div class="footer">
      <div class="footer_content">
        <h3 style="color:#ff8a23;">联系我们</h3>
        <p> 电话：{{indexData.telephone}}</p>
        <p> 邮箱：{{indexData.email}}</p>
        <p> 地址：{{indexData.address}}</p>
        <p>备案号：<a href="https://beian.miit.gov.cn/" target="_blank">粤ICP备19061618号</a></p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    data: function() {
        return {
          indexData:{},

        }
    },
    created: function() {
      this.initData();
    },
    methods: {
      initData() {
          var self = this;
          this.$http.get(self.globalUrl.indexInfo).then(function(res) {
              if (res.data.code == 200000) {
                  self.indexData = res.data.data;
              }
          });
      },
      clickToRouter(uri){
        this.$router.push(uri);
      }
    }
}


</script>


<style media="screen" lang="less" scoped>
/*0-768px以上宽度container为100%*/
.container {
 padding-right: 15px;
 padding-left: 15px;
 margin-right: auto;
 margin-left: auto;
}
/*768-992px以上宽度container为750px*/
@media (min-width: 768px) {
 .container {
 width: 750px;
 }
}
/*992-1200px以上宽度container为970px*/
@media (min-width: 992px) {
 .container {
 width: 970px;
 }
}
/*1200px以上宽度container为1170px*/
@media (min-width: 1200px) {
 .container {
 width: 1170px;
 }
}

header.header {
    z-index: 100;
    top: 0;
    left: 0;
    width: 100%;
    height: 80px;
    background: #409DDD;
    .logo {
        display: block;
        float: left;
        height: 63px;
        padding-top: 7px;
        width: 150px;
        text-align: center;
        color: #1ab394;
        line-height: 36px;
        font-size: 24px;
        img {
            height: 60px;
        }
    }
    .top_content {
        margin-left: 150px;
        padding: 7px;
        height: 66px;
        color: #ddd;
        line-height: 36px;
        &>ul.nav{
            cursor:pointer;
            max-height: 100%;
            &>li{
                float:left;
                padding     : 9px 10px 9px 15px;
                // border-bottom: 1px solid #23262E;
                &>a{
                    display: block;
                    color       : #fff;
                    i{
                        float: right;
                        line-height: 30px;
                        color   : #999;
                    }
                }
                &>a.router-link-active{
                    background-color: #ff8a23;
                }

                &:hover{
                    background-color: #4d515e;
                    &>ul.sub{
                      display: block;
                    }
                }

                ul.sub{
                    position:absolute;
                    z-index:100;
                    display: none;
                    li{
                       background-color: #4d515e;
                        display: block;
                        padding-top: 5px;
                        &>a{
                            max-width: 100%;
                            max-height: 100%;
                            color   : #ddd;
                            &:hover{
                                color   : #fff;
                            }
                        }
                        &>a.router-link-active{
                            color   : #fff;
                            background-color: #ff8a23;
                        }

                    }
                }
            }
        }
    }
}

.cpy_info{
  margin-top: 3px;
}

.footer {
    margin-top:3px;
    padding     : 9px 10px 9px 15px;
    height: 120px;
    background-color: #55585a;
    width: 100%;
    color: #fff;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    border-radius: 4px;
    &>.footer_content {
      margin: 0 auto;
      width: 70%;
    }
}

.article{
  margin-top: 3px;
  height: 300px;

  &>ul.article-list{

    &>li{
      text-overflow: ellipsis;

      &>a.router-link-active{
          color   : #fff;
          background-color: #ff8a23;
      }
    }
  }
}

.show-ellipsis {
  display: block;
  width: 100%;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}

.text2 {
/*多行*/
  width:100%;
  word-break:break-all;
  display:-webkit-box;
  -webkit-line-clamp:4;
  -webkit-box-orient:vertical;
  overflow:hidden;
}

</style>



// WEBPACK FOOTER //
// index.vue?46a2c9de